import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Components } from '@app/shared-modules/timeline/components';

@NgModule({
    declarations: [Components],
    exports: [Components],
    imports: [CommonModule],
})
export class TimelineModule {}
